export default __webpack_public_path__ + "static/media/img-time-km-es_es@2x.fa6dda7f.png";